import { ChevronLeft } from "lucide-react";

export const InfoRow = ({ icon: Icon, label, value, badge, chips, chevron = false }) => (
  <div className="flex items-center gap-3 py-3" data-testid="info-row">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
      <Icon className="h-5 w-5" />
    </span>
    <div className="min-w-0 flex-1">
      <div className="text-[11px] font-bold uppercase tracking-wide text-muted-foreground">{label}</div>
      {chips?.length ? (
        <div className="mt-1 flex flex-wrap gap-1.5" data-testid="info-row-chips">
          {chips.map((c) => (
            <span key={c} className="rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-bold text-primary">{c}</span>
          ))}
        </div>
      ) : (
        <div className="mt-0.5 flex items-center gap-2 truncate text-sm font-semibold">
          {value || "—"}
          {badge}
        </div>
      )}
    </div>
    {chevron ? <ChevronLeft className="h-4 w-4 shrink-0 text-muted-foreground/40 rtl:rotate-180" /> : null}
  </div>
);
